import React from 'react';
import ReactGA from 'react-ga';

 
export const initGA = () => {       
    ReactGA.initialize('UA-175554877-1'); // put your tracking id here
}